import type { AddItemRequest, Basket, UpdateBasketRequest } from '@/models/basket';
import AxiosFactory from '@/services/axiosFactory';
import type { AxiosResponse } from 'axios';

export default class BasketService {
    private client = AxiosFactory.create({
        baseURL: '/customerportal/basket/'
    });

    public async AddLineItem(basketGuid: string, request: AddItemRequest): Promise<AxiosResponse<void>> {
        return (await this.client).post(`${basketGuid}/lineItem`, request);
    }

    public async CreateBasket(email: string, debitoNumber: string): Promise<AxiosResponse<string>> {
        return (await this.client).post(`?email=${encodeURIComponent(email)}&debitorNumber=${debitoNumber}`);
    }

    public async DeleteLineItem(basketGuid: string, id: number): Promise<AxiosResponse<void>> {
        return (await this.client).delete(`${basketGuid}/lineItem/${id}`);
    }

    public async GetBasket(basketGuid: string): Promise<AxiosResponse<Basket>> {
        return (await this.client).get(basketGuid);
    }

    public async UpdateBasket(basketGuid: string, request: UpdateBasketRequest): Promise<AxiosResponse<Basket>> {
        return (await this.client).put(basketGuid, request);
    }

    public async UpdateLineItem(basketGuid: string, request: AddItemRequest): Promise<AxiosResponse<void>> {
        return (await this.client).put(`${basketGuid}/lineItem`, request);
    }
}
